// extracted by mini-css-extract-plugin
export default {"LoadingPageContainer":"style_LoadingPageContainer__5bwl7"};